import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-condition",
  "use": "icon-condition-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" id=\"icon-condition\"><defs><style type=\"text/css\"></style></defs><path d=\"M641.066667 500.821333v231.424l-256.213334 206.08V500.778667L84.736 213.333333V85.333333h854.826667v128l-298.496 287.488z m-42.666667 210.986667v-229.12l298.496-287.488V128H127.402667v67.114667l300.117333 287.488v366.634666l170.88-137.429333zM469.802667 618.666667v-164.992L222.122667 217.6a21.333333 21.333333 0 1 1 29.44-30.890667l260.906666 248.746667V618.666667a21.333333 21.333333 0 1 1-42.666666 0z\" p-id=\"1004\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/condition.svg
// module id = tC6+
// module chunks = 77